module.exports = __webpack_public_path__ + "img/kjsy_gallery5.342d9ae0.jpg";